import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import {
  AccessRequestsApiCreateUserAccessRequestRequest,
  AccessRequestSubmittedClientResponse,
} from "../../api/v1";

import useAccessRequestsApi from "./use-access-requests-api";

export default function useCreateUserAccessRequest() {
  const api = useAccessRequestsApi();

  const {
    mutate: createUserAccessRequest,
    mutateAsync: createUserAccessRequestAsync,
    ...rest
  } = useMutation<
    AccessRequestSubmittedClientResponse,
    AxiosError,
    AccessRequestsApiCreateUserAccessRequestRequest
  >(async (payload: AccessRequestsApiCreateUserAccessRequestRequest) => {
    const res = await api.createUserAccessRequest({
      createAccessRequestClientModel: {
        ...payload.createAccessRequestClientModel,
        run_pre_approval_validations: true,
      },
    });
    return res;
  });

  return {
    createUserAccessRequest,
    createUserAccessRequestAsync,
    ...rest,
  };
}
